import React from "react";

export const Viviendavis = () => {
  return (
    <section className="viviendavis_main" id="vivienda-vis">
      <article className="viviendavis_container">
        <div className="viviendavis_text">
          <div className="viviendavis_content">
            <div className="viviendavis_tilte">
              <h1>
                Sácale el jugo a <span>tu arriendo</span>
              </h1>
              <h2>Leasing habitacional para vivienda VIS</h2>
            </div>
            <section className="viviendavis_paragraf">
              <p>
                Pagar un arriendo en Colombia te sirve para cumplir una necesidad: tener un lugar
                para ti y para que viva tu familia… ¿Pero sabías que si sumas todas las cuotas de
                arriendo tienes para la cuota inicial y la totalidad de una casa o apartamento que
                sea tuyo?
              </p>
              <p className="paragraf_tow">
                Con el leasing habitacional aprovechas la plata del arriendo para construir un
                patrimonio para ti y tu familia.
              </p>
            </section>

            <div className="viviendavis_list">
              <ul>
                <li>
                  <button
                    onClick={() => {
                      window.open("https://api.whatsapp.com/send/?phone=+573105653998", "_blank");
                    }}
                  >
                    Hablar con <span>un asesor</span>{" "}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="viviendavis_imgs">
          <figure className="imgs_content">
            <img
              src="./assets/img/mg3.webp"
              alt="Invertir en Colombia desde el exterior mediante leasing"
            />
          </figure>
        </div>
      </article>
    </section>
  );
};
